export default __webpack_public_path__ + "static/media/shopify-partners-logo.4cba96eb.svg";